import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const OmnichannelPage = lazy(() => import('./pages/OmnichannelPage'));
const ChatWidgetPage = lazy(() => import('./pages/ChatWidgetPage'));
const VideoCallsPage = lazy(() => import('./pages/VideoCallsPage'));
const CollaborationPage = lazy(() => import('./pages/CollaborationPage'));
const CannedResponsesPage = lazy(() => import('./pages/CannedResponsesPage'));

export const CommunicationRoutes: RouteObject = {
  path: 'communication',
  element: <ModuleGuard moduleId="support.communication" />,
  handle: { crumb: 'Support Communication' },
  children: [
    { index: true, element: <Navigate to="omnichannel" replace /> },
    { path: 'omnichannel', element: <OmnichannelPage />, handle: { crumb: 'Omnichannel' } },
    { path: 'chat-widget', element: <ChatWidgetPage />, handle: { crumb: 'Chat Widget' } },
    { path: 'video-calls', element: <VideoCallsPage />, handle: { crumb: 'Video Calls' } },
    { path: 'collaboration', element: <CollaborationPage />, handle: { crumb: 'Collaboration' } },
    { path: 'canned-responses', element: <CannedResponsesPage />, handle: { crumb: 'Canned Responses' } },
  ],
};
